/*eslint-disable no-undef*/
import React, { Component } from 'react';
import './App.css';
import Login from './components/Login';
import { Card, Button, Heading, toaster, TextInput } from 'evergreen-ui';
import clearEnv from '@segment/clear-env';
import clearCookies from '@segment/clear-cookies';
import localStorage from 'localStorage';
import { Container, Row, Col } from 'reactstrap';

class App extends Component {
  constructor (props) {
    super(props);
    this.state = {
      utm: '',
    };

    this.updateUtm = this.updateUtm.bind(this);
  }

  updateUtm (val) {
    console.log(window.location);
    this.setState({utm: val});
  }

  render() {
    return (
      <div style={{backgroundColor:"#F5F6F7",minHeight:'100vh',layout:'flex',justifyContent: 'center'}}>
        <Container style={{paddingTop: 50,width:800,margin:'0px auto'}}>
          <Row style={{position:'relative',display:'flex'}}>
            <Col xs={12} sm={4} style={{width:'50%',padding: 20}}>
              <Card elevation={3} style={{padding: 15,marginBottom:30}} background={"white"}>
                <Heading size={500}>Initiate</Heading>
                <Heading size={100}>Enter tracking token</Heading>
                <div style={{marginBottom:10,marginTop:5}}>
                  <TextInput placeholder={"Token..."} style={{marginBottom:10}}/>
                  <Button appearance="primary" onClick={() => {
                    toaster.success(`Loading Deeploop.js`);
                  }}>Load script</Button>
                </div>
              </Card>
              <Card elevation={3} style={{padding: 15,marginBottom:30}} background={"white"}>
                <Heading size={500}>Identify</Heading>
                <Heading size={100}>By email</Heading>
                <div style={{marginBottom:10,marginTop:5}}>
                  <TextInput placeholder={"Email..."} style={{marginBottom:10}}/>
                  <Button appearance="primary" onClick={() => {
                    toaster.success(`Loading Deeploop.js`);
                  }}>Identify</Button>
                </div>
                <Heading size={100}>By UTM</Heading>
                <div style={{marginBottom:10,marginTop:5}}>
                  <TextInput placeholder={"UTM..."} style={{marginBottom:10}}/>
                  <Button appearance="primary" onClick={() => {
                    toaster.success(`Loading Deeploop.js`);
                  }}>Identify</Button>
                </div>
              </Card>
              <Card elevation={3} style={{padding: 15,marginBottom:30}} background={"white"}>
                <Heading size={500}>Page / Track</Heading>
                  <div style={{marginBottom:10,marginTop:20}}>
                    <Button appearance="primary" onClick={() => {
                      try {
                        deeploop.page();
                        toaster.success(`.page() event thrown`);
                      } catch (e) {
                        toaster.danger(`Something went wrong with .track()`);
                      }
                      }}>Throw .page()</Button>
                  </div>
                  <div style={{marginBottom:10}}>
                    <Button appearance="primary" onClick={() => {
                      console.log("Clear Cookies");
                      clearCookies();
                      }}>Throw .track()</Button>
                  </div>
                </Card>
            </Col>
            <Col xs={12} sm={4} style={{width:'50%',padding: 20}}>
              <Card elevation={3} style={{padding: 15,marginBottom:30}} background={"white"}>
                <Heading size={500}>Reset</Heading>
                <div style={{marginBottom:10,marginTop:20}}>
                  <Button appearance="primary" onClick={() => {
                    console.log("Clear Cookies");
                    clearCookies();
                    toaster.success(`Cookies cleared`);
                    }}>Clear cookies</Button>
                </div>
                <div style={{marginBottom:10}}>
                  <Button appearance="primary" onClick={() => {
                    console.log("Clear LS");
                    localStorage.clear();
                    toaster.success(`Local storage cleared`);
                    }}>Clear local storage</Button>
                </div>
                <div style={{marginBottom:10}}>
                  <Button appearance="primary" intent="danger" onClick={() => {
                    localStorage.clear();
                    clearCookies();
                    window.location.reload();
                    }}>Reset environment & reload</Button>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js